export default {"src":"/_next/static/media/cashews.978980e3.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};